import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = ({ items = [] }) => {
  const location = useLocation();

  // Default breadcrumb mapping based on routes
  const routeMapping = {
    '/novus-operations-hub': {
      label: 'Operations Hub',
      icon: 'Activity'
    },
    '/patient-care-analytics': {
      label: 'Patient Analytics',
      icon: 'Users'
    },
    '/vendor-performance-hub': {
      label: 'Vendor Management',
      icon: 'Truck'
    }
  };

  // Generate breadcrumb items if not provided
  const breadcrumbItems = items?.length > 0 ? items : [
    { label: 'Dashboard', path: '/', icon: 'Home' },
    routeMapping?.[location?.pathname] ? {
      label: routeMapping?.[location?.pathname]?.label,
      path: location?.pathname,
      icon: routeMapping?.[location?.pathname]?.icon,
      current: true
    } : null
  ]?.filter(Boolean);

  if (breadcrumbItems?.length <= 1) {
    return null;
  }

  return (
    <nav className="flex items-center space-x-2 text-sm text-text-secondary mb-6">
      {breadcrumbItems?.map((item, index) => (
        <React.Fragment key={item?.path || index}>
          {index > 0 && (
            <Icon name="ChevronRight" size={14} className="text-border" />
          )}
          
          {item?.current ? (
            <div className="flex items-center space-x-2 text-text-primary font-medium">
              {item?.icon && (
                <Icon name={item?.icon} size={16} color="var(--color-primary)" />
              )}
              <span>{item?.label}</span>
            </div>
          ) : (
            <Link
              to={item?.path}
              className="flex items-center space-x-2 hover:text-text-primary medical-transition"
            >
              {item?.icon && (
                <Icon name={item?.icon} size={16} />
              )}
              <span>{item?.label}</span>
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;